import React, { useState, useEffect } from 'react';

import { ContentBox } from "../../ContentBox"
import { SystemPromptInput } from '../../../Res/SystemPrompt';
import 'rc-datepicker/lib/style.css';
import moment from 'moment';
import { ManagementPrompt } from '../../../Res/ManagementPrompt';
import { setVal2Token, getval2Token, getUserInfoCompanyId } from '../../../../Login/Auth';

import { api_getAllPlayersFromGame, api_getScorerList } from '../../../../../api/MyStat/apiGame';
import { api_getLeagueGameTypeList } from '../../../../../api/MyStat/apiLeague';
import { TableListTitle, setTD, ListBox, } from '../../../../../item/ItemTableList';
import { KEY_GAME_STATUS, KEY_SCORER, KEY_SCORING_STATUS, ReqGameList, ReqGameDetail } from '../../../../../item/MyStat/ItemGame';
import { RespActionList, ReqAction2ActionList, ReqPitch2ActionList, KEY_ACTIONLIST_RESULTCODE, GAME_ACTIONLIST_TYPE_NACT_CODE, GAME_ACTIONLIST_TYPE_NACT, GAME_ACTIONLIST_TYPE_PITCH, GAME_ACTIONLIST_TYPE_IPS, GAME_ACTIONLIST_TYPE_IPO } from '../../../../../item/MyStat/actionList';
import { ActionListSearch1 } from './Action_List_Search1';
import { ActionListSearch2 } from './Action_List_Search2';
import { getKey } from '../../../../../item/ItemTools';

import html2pdf from "html2pdf.js"
import { AddButton } from '../../../Res/BaseButton';
import { createPortal } from 'react-dom';
import ReactDOM from 'react-dom'
import { Modal } from './Modal/modal';
import { ActionEditPitch } from './ActionEditPitch';
import { ActionEditBat } from './ActionEditBat';
import { api_getActionListByReqAction, api_getActionListByReqPitch } from '../../../../../api/MyStat/apiPlateRecord';


export function ActionList({ id, setIsLoading }) {
    let subtitle;
    const [open, setOpen] = useState(false);
    const [tokenId, setTokenId] = useState("")
    const [league_association_List, set_league_association_List] = useState([])
    const [league_association_arr, set_league_association_arr] = useState(undefined)
    const [game_type_arr, set_game_type_arr] = useState([])
    const [scorer_arr, set_scorer_arr] = useState([])

    const [game_id, set_game_id] = useState("")

    const [inning, set_inning] = useState("")
    const [inning_half, set_inning_half] = useState("")
    const [action_type, set_action_type] = useState("")
    const [action_code, set_action_code] = useState("")
    const [player_name, set_player_name] = useState("")
    const [result_code, set_result_code] = useState("")

    const [scorer, set_scorer] = useState("")
    const [game_status, set_sgame_status] = useState('')
    const [scoring_status, set_scoring_status] = useState('')

    const [actionSearchItems, setActionSearchItems] = useState([])
    const [pitchSearchItems, setPitchSearchItems] = useState([])

    const [teamList, setGameList] = useState([])
    const [page, setPage] = useState(1)
    const [limit] = useState(20)
    const [count, setCount] = useState(0)

    const [actionLists, setActionLists] = useState([])

    // const [mReqGameList, setReqGameList] = useState({})

    const [list_obj, set_list_obj] = useState({})
    // const [list_len, set_list_len] = useState(10)

    const [player_arr, set_player_arr] = useState([])

    useEffect(() => {
        if (id !== undefined && id !== tokenId) {
            var obj = getval2Token("ActionList", id)
            console.log(obj)
            set_game_id(obj.game_id)
            setTokenId(id)
        }
    }, [id])

    useEffect(() => {
        get_ScorerList()
        get_league_association()
    }, [])

    useEffect(() => {
        if (game_id !== "") {
            get_player_list()
            toSearchFromPage(page)
        }
    }, [game_id])

    useEffect(() => {
        if (id !== undefined && id !== tokenId && league_association_arr !== undefined) {
            var url = getval2Token("url", id)
            // console.log(url)
            setTokenId(id)
            var start = (url.page - 1) * limit;
            var mReqGameList = new ReqGameList({ start, limit })
            // if (url === "") {
            //     toSearch({ items: mReqGameList, page: url.page })
            // } else {
            //     mReqGameList.fromJson(url)
            //     console.log(mReqGameList)
            //     // set_team_name(mReqGameList.team_name)
            //     // set_league_association(mReqGameList.league_association)
            //     // set_game_activation(mReqGameList.game_activation)
            //     toSearch({ items: mReqGameList, page: url.page })
            // }
        }
    }, [id, league_association_arr])

    function set_act(action_type, code, current) {
        if (action_type === "Pitch")
            return <>{code} <br></br> {current}</>
        else
            return <>{code}</>
    }

    function check_status(type, before_status, after_status) {
        // console.log(type)
        if (type === "Not-Act") return <></>
        if (before_status === after_status)
            return <>{before_status}</>
        else
            return <>{before_status} <br></br> {after_status}</>
    }

    function set_transcript(items) {
        var html = <>
            {
                items.map((item) => {
                    return <div key={getKey({})}>{item}</div>
                })
            }
        </>
        return html
    }

    function set_act_string(list) {
        var html = <>
            {
                list.map((items) => {
                    if (typeof (items) === "string")
                        return <div key={getKey({})}>{items}</div>
                    else
                        return items.map((item) => {
                            return <div key={getKey({})}>{item}</div>
                        })
                })
            }
        </>
        return html
    }

    function set_Edit(key, isChoose) {
        // console.log(key)
        var filterEmpty = JSON.parse(JSON.stringify(actionLists))
        var temp = filterEmpty.find(item => {
            return item.record_id === key
        })
        temp.isChoose = isChoose
        // console.log(filterEmpty)
        setActionLists(filterEmpty)
    }

    function set_Save_Pitch(key, val) {
        var filterEmpty = JSON.parse(JSON.stringify(actionLists))
        var temp = filterEmpty.find(item => {
            return item.record_id === key
        })
        temp.pitch_type = val.pitch_type
        temp.pitch_speed = val.pitch_speed
        temp.video_timestamp = val.video_timestamp
        temp.isChoose = false
        // console.log(filterEmpty)
        setActionLists(filterEmpty)
    }

    function set_Save_Bat(key, val) {
        var filterEmpty = JSON.parse(JSON.stringify(actionLists))
        var temp = filterEmpty.find(item => {
            return item.record_id === key
        })
        // console.log(val)
        temp.action_detail = JSON.stringify(val.action_detail)
        temp.video_timestamp = val.video_timestamp
        // console.log(temp)
        temp.isChoose = false
        // console.log(filterEmpty)
        setActionLists(filterEmpty)
    }

    useEffect(() => {
        var contents = []
        var stick
        var i = 0;
        actionLists.forEach(item => {
            var mRespActionList = new RespActionList({})
            mRespActionList.fromJson(item)
            // console.log("[" + i + "]")
            // console.log(mRespActionList)
            i++;
            if (stick !== mRespActionList.offensive.stick) {
                if (stick !== undefined)
                    contents.push([])
                stick = mRespActionList.offensive.stick
            }


            var content = []
            // if (mRespActionList.action_type === GAME_ACTIONLIST_TYPE_PITCH || mRespActionList.action_type === GAME_ACTIONLIST_TYPE_IPS || mRespActionList.action_type === GAME_ACTIONLIST_TYPE_IPO) {
            //     content.push(setTD({ content: mRespActionList.get_opportunity({ index: i }), action: set_Edit, actionKey: mRespActionList.record_id, actionVal: true }))
            // } else {
            //     content.push(setTD({ content: mRespActionList.get_opportunity({ index: i }) }))
            // }
            content.push(setTD({ content: mRespActionList.get_opportunity({ index: i }) }))
            content.push(setTD({ content: set_act(mRespActionList.action_type, mRespActionList.get_act_code(), mRespActionList.get_act_current()) }))
            if (mRespActionList.action_type === GAME_ACTIONLIST_TYPE_PITCH){
                content.push(setTD({ content: mRespActionList.get_pitch_result(), action: set_Edit, actionKey: mRespActionList.record_id, actionVal: true }))
            }else{
                content.push(setTD({ content: mRespActionList.get_pitch_result() }))
            }
            content.push(setTD({ content: mRespActionList.get_play_result().join(",") }))
            content.push(setTD({ content: check_status(mRespActionList.action_type, mRespActionList.get_before_status(), mRespActionList.get_after_status()) }))
            if (mRespActionList.action_type === GAME_ACTIONLIST_TYPE_IPS || mRespActionList.action_type === GAME_ACTIONLIST_TYPE_IPO) {
                content.push(setTD({ content: set_act_string(mRespActionList.get_act()), action: set_Edit, actionKey: mRespActionList.record_id, actionVal: true }))
            }else{
                content.push(setTD({ content: set_act_string(mRespActionList.get_act()) }))
            }
            content.push(setTD({ content: <>{set_transcript(mRespActionList.get_transcript())}</>, align: "left" }))

            contents.push(content)
            // contents.push([<td  key={getKey({})} colSpan='7' ><div style={{wordWrap:'break-word', wordBreak:'break-all'}}>[{i}] {JSON.stringify(mRespActionList)}</div></td>])
            if (mRespActionList.isChoose) {
                if (mRespActionList.action_type === GAME_ACTIONLIST_TYPE_PITCH)
                    contents.push([<td key={getKey({})} colSpan='7'><ActionEditPitch setIsLoading={setIsLoading} mRespActionList={mRespActionList} set_Close={set_Edit} set_Save={set_Save_Pitch} /></td>])
                else if (mRespActionList.action_type === GAME_ACTIONLIST_TYPE_IPS || mRespActionList.action_type === GAME_ACTIONLIST_TYPE_IPO) 
                    contents.push([<td key={getKey({})} colSpan='7'><ActionEditBat setIsLoading={setIsLoading} mRespActionList={mRespActionList} set_Close={set_Edit} set_Save={set_Save_Bat} /></td>])
                }
            })
        // console.log(contents)
        var lb = {
            titles: [
                new TableListTitle('時機', 2),
                new TableListTitle('ACT', 1),
                new TableListTitle('投球結果', 1),
                new TableListTitle('打席結果', 2),
                new TableListTitle('壘上', 1),
                new TableListTitle('ACT數據', 2),
                new TableListTitle('成績', 3),
            ],
            contents
        }

        // console.log(lb)
        set_list_obj(lb)
        var len = contents.length
        if (len < 10)
            len = 10
        // set_list_len(len)

    }, [actionLists])

    const onChange = (key, val) => {
        console.log(key)
        console.log(val)
        switch (key) {
            // case KEY_GAME_NO:
            //     set_game_No(val)
            //     break;
            // case KEY_LEAGUE_ASSOCIATION:
            //     var filterEmpty = league_association_List.filter((item) => {
            //         return item.league_id === val;
            //     });
            //     console.log(filterEmpty[0].game_types)
            //     set_game_type_arr(filterEmpty[0].game_types)
            //     set_league_association(val)
            //     break;
            // case KEY_GAME_TYPE:
            //     set_game_type(val)
            //     break;
            // case KEY_GAME_ACTIVATION:
            //     set_game_type(val)
            //     break;
            // case KEY_TEAM_NAME:
            //     set_team_name(val)
            //     break;
            // case KEY_GAME_DATE_START:
            //     set_game_date_start(val)
            //     break;
            // case KEY_GAME_DATE_END:
            //     set_game_date_end(val)
            //     break;
            case KEY_GAME_STATUS:
                set_sgame_status(val)
                break;
            case KEY_SCORER:
                set_scorer(val)
                break;
            case KEY_SCORING_STATUS:
                set_scoring_status(val)
                break;

            default:
                break;
        }
    }

    // const onChange = (jsDate, dateString) => {
    //     //console.log(jsDate)
    //     //console.log(dateString)
    //     if (dateString === "Invalid date") {
    //       setBirthError(true)
    //     } else {
    //       setBirthError(false)
    //       set_player_DOB(dateString)
    //     }
    //   }

    function get_player_list() {
        var mReqGameDetail = new ReqGameDetail({
            game_id
        })

        // console.log("get_player_list")
        // console.log(mReqGameDetail)

        api_getAllPlayersFromGame({
            mReqGameDetail,
            success: (obj) => {
                // console.log("api_getAllPlayersFromGame")
                var items = obj.items
                const result = items.filter((items, index, arr) => {
                    return arr.findIndex(s => items.code === s.code) === index;
                });
                //   console.log(result)
                set_player_arr(result)
                // if (setIsLoading !== undefined)
                //   setIsLoading(false)
            },
            failure: (err) => {
                // if (setIsLoading !== undefined)
                //   setIsLoading(false)
            }
        })
    }

    function get_ScorerList() {
        api_getScorerList({
            companyId: getUserInfoCompanyId(),
            success: (obj => {
                console.log(obj)
                set_scorer_arr(obj.list)
            }),
            failure: (err) => {
            }
        })
    }

    function get_league_association() {
        if (setIsLoading !== undefined)
            setIsLoading(true)
        api_getLeagueGameTypeList({
            success: (obj) => {
                // console.log(obj)
                // var arr = [{ val: "", name: "全部" }]
                var arr = []
                obj.items.forEach(item => {
                    arr.push({ val: item.league_id, name: item.league_name })
                })
                console.log(arr)
                set_league_association_arr(arr)
                set_league_association_List(obj.items)
                // if (setIsLoading !== undefined)
                //     setIsLoading(false)
            },
            failure: (err) => {
                // if (setIsLoading !== undefined)
                //     setIsLoading(false)
            }
        })
    }

    function toSearchFromPage({ page = 1 }) {
        setPage(page)
        var type = getval2Token("type", id)
        if (type === '')
            type = 'action'
        // console.log('type')
        // console.log(type)
        var searchItems
        if (type === "action") {
            searchItems = getval2Token("actionSearch", id)
            toActionSearch(searchItems, page)
        } else if (type === "pitch") {
            searchItems = getval2Token("pitchSearch", id)
            toPitchSearch(searchItems, page)
        }
        // var mReqRecruitmentContractorStatusList = new ReqRecruitmentContractorStatusList({ companyId, start, limit })
        // mReqRecruitmentContractorStatusList.fromJson(url)
        // console.log(mReqRecruitmentContractorStatusList)
        // mReqRecruitmentContractorStatusList.page = page
        // setVal2Token("url", mReqRecruitmentContractorStatusList, id)
        // setReqRecruitmentContractorStatusList(mReqRecruitmentContractorStatusList)
        // getRecruitmentContractorStatusList(mReqRecruitmentContractorStatusList)
    }


    function toActionSearch(searchItems, page = 1) {
        console.log("game_id")
        console.log(game_id)
        console.log('toActionSearch')
        console.log(searchItems)
        var start = (page - 1) * limit;
        var mActionList = new ReqAction2ActionList({ game_id, start, limit })
        if (searchItems !== null && searchItems !== '')
            mActionList = getSearchItemsInfo(searchItems, mActionList)

        setPage(page)
        setVal2Token("type", "action", id)
        setVal2Token("actionSearch", searchItems, id)
        setVal2Token("pitchSearch", null, id)
        // console.log("toActionSearch")
        // console.log(mActionList)
        // // setActionSearchItems(searchItems)
        // // toSearch({ items: mReqGameList })
        getActionList({ mActionList })
    }

    function toPitchSearch(searchItems, page = 1) {
        // console.log(searchItems)
        console.log("game_id")
        console.log(game_id)
        console.log('toPitchSearch')
        console.log(searchItems)
        var start = (page - 1) * limit;
        var mActionList = new ReqPitch2ActionList({ game_id, start, limit })
        console.log(mActionList)
        mActionList = getSearchItemsInfo(searchItems, mActionList)
        setPage(page)
        setVal2Token("type", "pitch", id)
        setVal2Token("actionSearch", null, id)
        setVal2Token("pitchSearch", searchItems, id)
        getActionList({ mActionList, byAction: false })
        // setActionSearchItems(searchItems)
        // toSearch({ items: mReqGameList })
    }

    function getSearchItemsInfo(searchItems, mActionList) {
        searchItems.forEach((boxItem) => {
            if (Array.isArray(boxItem)) {
                boxItem.forEach(item => {
                    if (item.key === undefined) {
                    } else if (item.key === KEY_ACTIONLIST_RESULTCODE) {
                        var arr = []
                        if (item.val !== "")
                            item.val.forEach((val) => {
                                arr.push(val.value)
                                // console.log(val.value)
                            })
                        mActionList[item.key] = arr.join(",")
                    } else {
                        mActionList[item.key] = item.val
                    }
                })
            }
        })
        return mActionList
    }

    function getActionList({ mActionList, byAction = true }) {
        if (setIsLoading !== undefined)
            setIsLoading(true)
        console.log("mActionList")
        console.log(mActionList)
        if (byAction) {
            api_getActionListByReqAction({
                mActionList,
                success: (obj) => {
                    console.log(obj)
                    setActionLists(obj.items)
                    setCount(obj.count)
                    setIsLoading(false)
                },
                failure: (err) => {
                    console.log(err)
                    setIsLoading(false)
                }
            })
        } else {
            api_getActionListByReqPitch({
                mActionList,
                success: (obj) => {
                    console.log(obj)
                    console.log(obj.count)
                    setActionLists(obj.items)
                    setCount(obj.count)
                    setIsLoading(false)
                },
                failure: (err) => {
                    console.log(err)
                    setIsLoading(false)
                }

            })
        }
    }


    function toPdf() {
        var element = document.getElementById('element-to-print');
        var opt = {
            margin: 1,
            filename: 'myfile.pdf',
            image: { type: 'jpeg', quality: 0.98 },
            html2canvas: { scale: 2 },
            jsPDF: { unit: 'in', format: 'letter', orientation: 'portrait' }
        };

        // New Promise-based usage:
        html2pdf().from(element).set(opt).save();

        // // Old monolithic-style usage:
        // html2pdf(element, opt);
    }

    var baseTitle = "Action List"
    var baseContent =
        <>
            <ListBox row={7} lt={limit} lb={list_obj} count={count} page={page} sp={toSearchFromPage} />

            {/* <AddButton name={"pdf"} action={toPdf} /> */}
        </>
    return (
        <>
            <div id="element-to-print">
                <ActionListSearch1 action={toActionSearch} items={actionSearchItems} playerItems={player_arr} onChange={onChange} />
                <ActionListSearch2 action={toPitchSearch} items={actionSearchItems} playerItems={player_arr} onChange={onChange} />
                <ContentBox title={baseTitle} content={baseContent} />
                <ManagementPrompt />
                <SystemPromptInput />
            </div>

            {/* <div className="component">
                <button onClick={() => setOpen(true)}>Open Modal</button>

                {open && (
                    <Modal open={open} toggle={setOpen}>
                        <h1>Hello Modal</h1>

                    </Modal>
                )}
            </div> */}
        </>
    )
}

